import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ui-propulsion/react-components';
import TextField from './text-field';
import PasswordField from './password-field';
import classNames from 'classnames';
import FillMe from './fill-me';
import Spinner from './spinner';

class CreateAccount extends PureComponent {

  state = {
    password: '',
    confirmPassword: '',
    disableAction: false
  }

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.handleSubmit(e);
    }
  }

  onConfirmPasswordChange = (e) => {
    const { value: confirmPassword } = e.target;
    this.setState({ confirmPassword }, () => {
      const {
        errors,
        actions: {
          checkMatchingPassword
        }
      } = this.props;

      const {
        password
      } = this.state;

      if (errors.passwordConfirm) {
        checkMatchingPassword(password, confirmPassword);
      }
    });
  }

  onPasswordChange = (e) => {
    const { value: password } = e.target;
    this.setState({ password }, () => {
      const {
        errors,
        actions: {
          validatePasswordField
        }
      } = this.props;

      const {
        confirmPassword
      } = this.state;

      if (errors.password || errors.passwordConfirm) {
        validatePasswordField(password, confirmPassword);
      }
    });
  }

  onConfirmPasswordBlur = () => {
    const { checkMatchingPassword } = this.props.actions;
    const { password, confirmPassword } = this.state;
    checkMatchingPassword(password, confirmPassword);
  }

  handleEmailChange = (e) => {
    const { actions: { enterPracticeEmail }, errors } = this.props;
    const { target: { value } } = e;
    const runValidation = errors.practiceEmail ? true : false;
    enterPracticeEmail(value, runValidation);
  };

  handleEmailBlur = (e) => {
    const { enterPracticeEmail } = this.props.actions;
    const { target: { value } } = e;
    enterPracticeEmail(value, true);
  };

  handleNameChange = (e) => {
    const { validatePasswordField } = this.props.actions;
    const { confirmPassword } = this.state;
    const { target: { value } } = e;
    validatePasswordField(value, confirmPassword);
  }

  handleSubmit = () => {
    this.setState({ disableAction: true}, () => {
      const { createAccount } = this.props.actions;

      const { email } = this.props.practice;
      const { password, confirmPassword } = this.state;
      createAccount({ email, password, confirmPassword })
        .then(() => {
          this.props.history.push('/patientsolutions/enroll/contact-information');
        })
        .catch(({ status }) => {
          if (status && status !== 400) {
            window.location.href = '/patientsolutions/enroll/error';
            return;
          }
          this.setState({ disableAction: false});
        });
    });
  }

  handleFillMe = (e) => {
    this.setState({
      password: 'welcome1',
      confirmPassword: 'welcome1'
    });
  }

  render() {
    const { processingSubmit } = this.props.onboarding;
    const disableAction = this.state.disableAction;
    const className = classNames('button-submit', {
      'disabled': disableAction
    });

    const buttonProps = {
      'data-test-id': 'create-account-button',
      'aria-label': 'practice submit button',
      className,
      onClick: this.handleSubmit
    };

    if (disableAction) {
      buttonProps.disabled = true;
    }

    return <section className="create-account-section">
      <h1 className='section-title'>Create your practice’s account</h1>
      <p>
        Your account is used to access your Practice Center. Once your account is created, any registration information will be automatically saved in case you need to exit and return to complete.
      </p>
      <form>
        <TextField
          aria-required
          onChange={this.handleEmailChange}
          onBlur={this.handleEmailBlur}
          errorMsg={this.props.errors.practiceEmail}
          defaultValue={this.props.practice.email}
          className='input-helper'
          htmlFor='create_account_email'
          labelText='Email'
          labelClassName='section-label'
        />

        <PasswordField
          aria-required
          onBlur={this.handleNameChange}
          onChange={this.onPasswordChange}
          className='input-helper password-field-with-hint'
          htmlFor='practice_password'
          labelText='Create Password'
          labelClassName='section-label'
          helperTextClassName='section-helper-txt'
          helperText='Must contain 8 characters, with at least one letter and one number; special characters can only include !, @, #, $, or %.'
          errorMsg={this.props.errors.password}
          onKeyDown={this.handleKeyDown}
          value={this.state.password}
        />

        <PasswordField
          aria-required
          onInput={this.onConfirmPasswordChange}
          onBlur={this.onConfirmPasswordBlur}
          className='input-helper'
          htmlFor='practice_password_confirm'
          labelText='Confirm Password'
          labelClassName='section-label'
          errorMsg={this.props.errors.passwordConfirm}
          onKeyDown={this.handleKeyDown}
          value={this.state.confirmPassword}
        />

        <div className='action-area'>
          <Button {...buttonProps}>
            <span className='button-submit-text'>Create Account</span>
          </Button>
        </div>

        <FillMe
          handleOnClick={this.handleFillMe}
          env={this.props.env}
        ></FillMe>

        { processingSubmit && <Spinner processingSubmit={processingSubmit}/> }

      </form>
    </section>;
  }
}

CreateAccount.propTypes = {
  errors: PropTypes.shape({
    practiceEmail: PropTypes.string,
    password: PropTypes.string,
    passwordConfirm: PropTypes.string
  }),
  onboarding: PropTypes.shape({
    processingSubmit: PropTypes.bool
  }),
  practice: PropTypes.shape({
    email: PropTypes.string
  }),
  env: PropTypes.string,
  actions: PropTypes.shape({
    checkMatchingPassword: PropTypes.func,
    validatePasswordField: PropTypes.func,
    enterPracticeEmail: PropTypes.func
  }),
  history: PropTypes.shape({
    push: PropTypes.func
  })
};

export default CreateAccount;


